/**
 * @file reducers/App/reducer.js
 * @copyright 2016 CBC/Radio-Canada. All rights reserved.
 */

import { createSlice } from "@reduxjs/toolkit";

import { generateApp as initialAppState } from "../../actions/App/utils";

const appSlice = createSlice({
    name: "app",
    initialState: initialAppState(),
    reducers: {
        set_app_state: (state, action) => {
            return {
                ...state,
                ...action.payload.app,
            };
        },
        app_reset: () => {
            return initialAppState();
        },
    },
});

export const { set_app_state, app_reset } = appSlice.actions;

export default appSlice.reducer;
